import styled from "styled-components";

import { COLORS } from "../../components/styled";

interface WelcomePageImageBackgroundProps {
  url: string;
}

export const WelcomePageImageBackground = styled.div<WelcomePageImageBackgroundProps>`
  display: flex;
  flex: 1;
  padding: 0;
  background: url(${({ url }) => url});
  background-size: 130%;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const WelcomePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${COLORS.BLACK_BACKGROUND_OPACITY_40};
  justify-content: center;
  align-items: center;
`;

export const WelcomeContentCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const WelcomeContentBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 10% 16px 20% 16px;
  align-items: center;
`;

export const WelcomePageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100% - 90px);
  width: 100%;
  max-width: 900px;  /* Add max-width here */
  margin: 0 auto; /* Center the content if the screen is wider than max-width */
`;

export const WelcomePageButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  max-width: 900px;

  position: fixed;     /* Keep the "Check Out Your Photos" button fixed */
  bottom: 59px;        /* Pin it slightly above the bottom */
  left: 50%;
  transform: translateX(-50%);  /* Center horizontally */
  background-color: transparent;  /* No white background */
  z-index: 1000;      /* Keep it on top of other elements */
  padding: 10px;
`;

export const WelcomePageOptOutButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 70%;
  margin-top: 10px;

  position: fixed;     /* Fix it below the "Check Out" button */
  bottom: 10px;        /* Place it at the very bottom */
  left: 50%;
  transform: translateX(-50%);  /* Center horizontally */
  padding-top: 10px;
  z-index: 999;        /* Ensure it's just below the "Check Out" button */
`;

export const WelcomePageLogoPart = styled.div`
  position: absolute;
  top: 10%; /* 10% from the top of the nearest relatively positioned ancestor */
  left: 50%;
  transform: translateX(-50%); /* Centers the element horizontally */
  height: 77px;
  min-height: 77px;
  align-items: center;
`;

export const WelcomePageImagePart = styled.div`
  display: flex;
  width: 60%;  /* increased from 60% */
  height: 15%; /* increased from 15% */
  min-height: 15%; /* increased from 15% */
  padding: 10px 0px 10px 0px;
  align-items: center;
  justify-content: center;
`;

export const WelcomePageTextPart = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 210px;
  padding: 10px 0px;
  align-items: center;
  justify-content: center;
  padding-top: 110px;
  padding-bottom: 100px; /* Space between text and buttons */

  @media (max-width: 768px) { /* Adjusts for screens narrower than 768px, typically mobile devices */
    padding-top: 140px; /* Reduce padding-top for mobile */
  }
`;

export const WelcomePageAdvPart = styled.div`
  display: flex;
  width: 100%;
  height: 100px;
  padding: 10px 0px 10px 0px;
  align-items: center;
  justify-content: center;
`;
